module.exports = __webpack_public_path__ + "img/device_1006_1.aaba3478.svg";